import { jsx as C } from "react/jsx-runtime";
import m, { useRef as h, useCallback as w, useEffect as x } from "react";
import { useForwardedRef as y } from "../../node_modules/@bedrock-layout/use-forwarded-ref/lib/index.m.es.js";
import c from "../../node_modules/beautiful-react-hooks/esm/usePreviousValue.es.js";
const A = [{
  transform: "scale(1)"
}, {
  transform: "scale(1.5)"
}, {
  transform: "scale(1)"
}], T = {
  duration: 500,
  easing: "ease"
}, _ = m.forwardRef(function({
  as: p,
  triggerValue: o,
  children: t,
  animationEnabled: a = !0,
  effect: f = A,
  timeline: i = T,
  ...d
}, l) {
  const R = p || "div", u = y(l), e = h(null), v = w((n) => {
    u.current = n, n !== null && "animate" in n && (e.current = n.animate(f, i), e.current.finish());
  }, [f, u, i]), r = c(o), s = c(t);
  return x(() => {
    var n;
    a && ((n = e.current) == null ? void 0 : n.playState) === "finished" && (o ? r !== void 0 && r !== o : s !== void 0 && s !== t) && e.current.play();
  }, [t, a, o, r, s]), /* @__PURE__ */ C(R, { ref: v, ...d, children: t });
}), S = m.memo(_);
export {
  S as default
};
//# sourceMappingURL=ChangeAnimation.es.js.map
